import api from './api';
import { logging } from './logging';

// Assuming the backend returns arrays of these types
// These should be updated to match the actual Prisma models
export interface PaperType {
  id: string;
  name: string;
  displayCode?: string | null;
  brand: string;
  category?: string;
  mediaType?: string;
  weightGsm?: number;
  widthIn?: number;
  lengthIn?: number;
  isRoll?: boolean;
  available?: boolean;
  description?: string;
  priceIndex?: number | null;
}

export interface Printer {
  id: string;
  name: string;
  brand: string;
  model: string;
  description?: string;
  priceIndex?: number | null;
}

/**
 * Fetches all available paper types from the server.
 */
export const getPaperTypes = async (): Promise<PaperType[]> => {
  try {
    const response = await api.get<PaperType[]>('/paper-types');
    return response.data;
  } catch (error) {
    logging.error('Failed to fetch paper types', { error });
    throw error;
  }
};

/**
 * Fetches all available printers from the server.
 */
export const getPrinters = async (): Promise<Printer[]> => {
  try {
    const response = await api.get<Printer[]>('/printers');
    return response.data;
  } catch (error) {
    logging.error('Failed to fetch printers', { error });
    throw error;
  }
};
